import { useEffect, useState } from "react";

const COLORS = ["#C63B2E", "#E0A12B", "#D9732B", "#B03A46", "#E8C547"];
const LEAVES = Array.from({ length: 16 }, (_, i) => ({
  left: (i * 6.7 + 3) % 96,
  delay: (i * 0.45) % 3.5,
  duration: 6.5 + (i % 5) * 0.9,
  size: 26 + (i % 4) * 10,
  color: COLORS[i % COLORS.length],
  sway: 26 + (i % 3) * 22,
}));

const FLAKES = Array.from({ length: 18 }, (_, i) => ({
  left: (i * 5.9 + 1.5) % 98,
  delay: (i * 0.6) % 4.5,
  duration: 8 + (i % 5) * 1.1,
  size: 7 + (i % 3) * 4,
  drift: 18 + (i % 4) * 16,
}));

const MapleLeaf = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 1.8 13.9 6.6 18.6 4.2 17.2 9 22 10.1 18.2 12.7 20.8 16.6 15.2 15.8 14.2 21.6 12 18.2 9.8 21.6 8.8 15.8 3.2 16.6 5.8 12.7 2 10.1 6.8 9 5.4 4.2 10.1 6.6Z"
      fill={color}
    />
    <path d="M12 10.5 12 19.5" stroke="rgba(0,0,0,0.3)" strokeWidth="1" strokeLinecap="round" />
  </svg>
);

const Flake = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <g stroke="rgba(255,255,255,0.9)" strokeWidth="1.4" strokeLinecap="round">
      <path d="M12 2v20M3.3 7l17.4 10M20.7 7 3.3 17" />
    </g>
    <circle cx="12" cy="12" r="2" fill="rgba(255,255,255,0.95)" />
  </svg>
);

export default function FallingLeaves() {
  const [done, setDone] = useState(false);
  const [gone, setGone] = useState(false);

  const month = new Date().getMonth();
  const isWinter = month === 11 || month <= 1;
  const isAutumn = month >= 8 && month <= 10;
  const season = isWinter ? "snow" : isAutumn ? "leaves" : null;

  useEffect(() => {
    const t1 = setTimeout(() => setDone(true), 12000);
    const t2 = setTimeout(() => setGone(true), 14000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (!season || gone) return null;

  return (
    <div
      data-testid="falling-leaves"
      aria-hidden="true"
      className={`leaves-overlay ${done ? "leaves-done" : ""} pointer-events-none fixed inset-0 z-[70] overflow-hidden`}
    >
      {season === "leaves" && LEAVES.map((leaf, i) => (
        <span
          key={`leaf-${i}`}
          className="leaf"
          style={{
            left: `${leaf.left}%`,
            animationDuration: `${leaf.duration}s`,
            animationDelay: `${leaf.delay}s`,
            "--sway": `${leaf.sway}px`,
          }}
        >
          <MapleLeaf size={leaf.size} color={leaf.color} />
        </span>
      ))}
      {season === "snow" && FLAKES.map((flake, i) => (
        <span
          key={`flake-${i}`}
          className="snowflake"
          data-testid={i === 0 ? "snowflake-first" : undefined}
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.duration}s`,
            animationDelay: `${flake.delay}s`,
            "--drift": `${flake.drift}px`,
          }}
        >
          <Flake size={flake.size} />
        </span>
      ))}
    </div>
  );
}
